export default __webpack_public_path__ + "locales/el-GR/FormGallery.json?hash=105f70433c9a1538a9adf94d044bc7bb";